export default function NotFound() {
  return (
    <div className="container-fluid text-center">
      <p>There's no page at this URL.</p>
    </div>
  );
}
